import { render, staticRenderFns } from "./VoteHistory.vue?vue&type=template&id=4d7b2194&scoped=true&"
import script from "./VoteHistory.vue?vue&type=script&lang=js&"
export * from "./VoteHistory.vue?vue&type=script&lang=js&"
import style0 from "./VoteHistory.vue?vue&type=style&index=0&id=4d7b2194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b2194",
  null
  
)

export default component.exports